import { Injectable } from "@angular/core";
import { IID_OL_RISORSA } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolRisorsaStore } from "./iidOlRisorsa.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.OLO_RISORSA)
export class IIDolRisorsaQuery extends AbstractInterfaceDataQuery<IID_OL_RISORSA> {
  constructor(protected store: IIDolRisorsaStore) {
    super(store);
  }
}
